export default __webpack_public_path__ + "static/media/yeopen_medium@2x.df7419c4.jpg";